<template>
  <div class="center calculator">
    <v-layout row justify-center>
      <v-card flat max-width="500">
        <!--<iframe src="https://juliazhaohomes.com/home-mortgage-calculator" frameborder="0" style="display: block;overflow:hidden;height: 100vh;width: 100vw;"></iframe>-->
        <v-card-title primary-title>
          <div class="center">
            <span class="headline mb-0 pl-2">按揭计算器</span>
          </div>
        </v-card-title>
        <div style="padding-bottom: 25px"></div>
        <div style="min-width: 240px; min-height: 450px">
          <v-form v-model="valid">
            <v-text-field
              id="totalAmount"
              v-model="totalAmount"
              :rules="[rules.required]"
              label="房产总价(美元) *"
              required
            ></v-text-field>

            <v-text-field
              id="downPayment"
              v-model="downPayment"
              label="首付(美元)"
            ></v-text-field>
            <v-text-field
              id="rate"
              v-model="rate"
              :rules="[rules.required]"
              label="年利率 (%) *"
              required
            ></v-text-field>
            <v-text-field
              id="period"
              v-model="period"
              :rules="[rules.required]"
              label="还款周期 (年) *"
              required
            ></v-text-field>
            <v-btn @click="submit">计算</v-btn>
          </v-form>
          <div v-if="result" style="color: green; padding-top: 10px">
            <p>每月还贷:<br />{{ result }}美元</p>
          </div>
        </div>
        <v-card-text class="back-btn">
          <v-btn small rounded @click="back">
            <v-icon small color="pink">fas fa-chevron-left</v-icon>&nbsp;返回
          </v-btn>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "calculator",
  data() {
    return {
      totalAmount: null,
      downPayment: 0,
      rate: 5,
      period: 30,
      result: null,
      rules: {
        required: (value) => !!value || " ",
      },
      valid: true,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.homeStore.isMobile,
      calculatePrice: (state) => state.homeStore.calculatePrice,
    }),
    flex: {
      get() {
        if (this.isMobile) return "xs12";
        return "xs6";
      },
      set(val) {},
    },
  },
  created() {
    this.totalAmount = this.calculatePrice ? this.calculatePrice : 100000;
  },
  methods: {
    submit: function () {
      if (
        !this.totalAmount ||
        this.totalAmount <= 0 ||
        !this.rate ||
        !this.period
      )
        return;
      if (!this.downPayment) this.downPayment = 0;
      let p = this.totalAmount - this.downPayment;
      let r = this.rate / 12 / 100;
      let n = this.period * 12;
      let rf = Math.pow(1 + r, n);
      this.result = (p * ((r * rf) / (rf - 1))).toFixed(2);
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
@import "../calculator.css";
</style>
